module.exports = __webpack_public_path__ + "static/media/enterprise-landscape.d0f9ab9e.jpg";